import { useContext } from "react";
import { useSelector } from "react-redux";
import { Project, Identifiable, ProjectResource } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeResourceFromProject(
    request: Boundaries["removeResourceFromProject"]["request"],
  ): void;
}

function useRemoveResourceFromProject(
  project: Identifiable<Project>,
  projectResource: Identifiable<ProjectResource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveResourceFromProjectRequestPending(
        project,
        projectResource,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveResourceFromProjectRequestSuccess(
        project,
        projectResource,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveResourceFromProjectRequestFailure(
        project,
        projectResource,
      ),
    ),
    removeResourceFromProject: core.removeResourceFromProject,
  };
}

export { useRemoveResourceFromProject };
